import React from 'react';

import ratnaImage from '../../../images/discovery/ratna.svg';
import { dayjs } from '../../../utils/dayjs-utils';
import { timeAgo } from '@/utils/ts/stringUtils';

export default function RatnaNotification({ notification }) {
  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className='unread-dot'></div>
      <div className="avatar-div">
        <img src={ratnaImage} alt="ratna" width={36} style={{ marginLeft: -6 }} />
      </div>
      <div className="text-div" style={{ marginLeft: 6 }}>
        <h3 className="title">{notification?.title}</h3>
        <p className="description">{notification?.content?.body}</p>
        <p className="timestamp" style={{ paddingTop: 8 }}>
          {timeAgo(notification?.createdAt)}
        </p>
      </div>
    </div>
  );
}
